import { extendTheme } from '@chakra-ui/react';

// FIXME components package breaks with this
// putting it here for now
export const falconTheme = extendTheme({
    colors: {
        primary: {
            50: '#e3f2f9',
            100: '#c5e4f3',
            200: '#a2d4ec',
            300: '#7ac1e4',
            400: '#47a9da',
            500: '#0088cc',
            600: '#007ab8',
            700: '#006ba1',
            800: '#005885',
            900: '#003f5e',
        },
        secondary: {
            50: '#f7f7f7',
            100: '#e3e3e3',
            200: '#c8c8c8',
            300: '#a4a4a4',
            400: '#8e8e8e',
            500: '#757575',
            600: '#5c5c5c',
            700: '#424242',
            800: '#292929',
            900: '#121212',
        },
        info: {
            50: '#e0f7fa',
            100: '#b2ebf2',
            200: '#80deea',
            300: '#4dd0e1',
            400: '#26c6da',
            500: '#00bcd4',
            600: '#00acc1',
            700: '#0097a7',
            800: '#00838f',
            900: '#006064',
        },
        success: {
            50: '#e8f5e9',
            100: '#c8e6c9',
            200: '#a5d6a7',
            300: '#81c784',
            400: '#66bb6a',
            500: '#4caf50',
            600: '#43a047',
            700: '#388e3c',
            800: '#2e7d32',
            900: '#1b5e20',
        },
        warn: {
            50: '#fff8e1',
            100: '#ffecb3',
            200: '#ffe082',
            300: '#ffd54f',
            400: '#ffca28',
            500: '#ffc107',
            600: '#ffb300',
            700: '#ffa000',
            800: '#ff8f00',
            900: '#ff6f00',
        },
        danger: {
            50: '#ffebee',
            100: '#ffcdd2',
            200: '#ef9a9a',
            300: '#e57373',
            400: '#ef5350',
            500: '#f44336',
            600: '#e53935',
            700: '#d32f2f',
            800: '#c62828',
            900: '#b71c1c',
        },
    },
    fonts: {
        heading: `'Open Sans', sans-serif`,
        body: `'Raleway', sans-serif`,
    },
});
